import { Center } from '@chakra-ui/react'

export default Center
